import { render, staticRenderFns } from "./CommentFB.vue?vue&type=template&id=3fa60f8a&"
import script from "./CommentFB.vue?vue&type=script&lang=js&"
export * from "./CommentFB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports